<script setup lang="ts">
import type { Options } from '@/lib/trashsim';
import { computed } from 'vue';

const props = defineProps<{
    modelValue: Options
}>()
const emits = defineEmits<{
    ( e: 'update:modelValue', value: Options): void
}>()

const options = computed({
    get: () => props.modelValue,
    set: (value: Options) => emits('update:modelValue', value)
})

</script>

<template>
    <div id="options">
        <h3 class="subtitle">{{ $t('home.options.title') }}</h3>
        <div id="options-container">
            <ul>
                <li class="enabled">
                    <label>
                        <input type="checkbox" disabled checked />
                        <span>{{ $t('home.options.feature.javascriptmw') }}</span>
                    </label>
                    <div class="extra">
                        <label>
                            <span>{{ $t('home.options.workercount') }}</span>
                            <input type="number" v-model="options.workerCount">
                        </label>
                    </div>
                </li>
                <li>
                    <label>
                        <span>{{ $t('home.options.entityinfo') }}</span>
                        <br>
                        <textarea v-model="options.entities" disabled></textarea>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>